import React from 'react';
import cls from 'classnames';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import { Weekdays } from '../Common';
import DayResourcesPanel from './DayResourcesPanel';
import DayDetailsPanel from './DayDetailsPanel';

export default class DayEntry extends React.Component {
    render() {
        const { wjr, dayOfDate, i, flaggerGroup } = this.props;

        const dayObj = Weekdays[moment(dayOfDate).day()];
        const dayName = dayObj.name.toLowerCase();
        const dayOfWeek = moment(dayOfDate).day();

        const flaggerResource = wjr.jobResources.find(
            (jr) => jr.applicationGroupId == flaggerGroup.id
        );

        const relevantJobContractPhases = wjr.jobContractPhases.filter(
            (jcp) => jcp.dayOfWeek == dayOfWeek
        );

        const { jobOverrides, jobResources } = wjr;
        const jobOverride =
            jobOverrides.find((jo) => jo.overrideDate == dayOfDate) || {};

        return (
            <div
                key={`${wjr.key}-${i}`}
                className={cls('p-3', { 'border-top': i > 0 })}
            >
                <div className="font-weight-bold mb-3">
                    {moment(dayOfDate).format(
                        MomentDateFormat.WeekDayNameAndDate
                    )}
                </div>

                <div className="row">
                    <div className="col-xl-6 mb-3">
                        <DayResourcesPanel
                            wjrKey={wjr.key}
                            weekOfDate={wjr.weekOfDate}
                            dayName={dayName}
                            jobResources={wjr.jobResources}
                            flaggerResource={flaggerResource}
                            flaggerGroup={flaggerGroup}
                            {...this.props}
                        />
                    </div>

                    <div className="col-xl-6 mb-3">
                        <DayDetailsPanel
                            wjrKey={wjr.key}
                            weekOfDate={wjr.weekOfDate}
                            dayOfWeek={dayOfWeek}
                            dayName={dayName}
                            dayOfDate={dayOfDate}
                            i={i}
                            relevantJobContractPhases={
                                relevantJobContractPhases
                            }
                            jobOverrides={jobOverrides}
                            jobOverride={jobOverride}
                            jobResources={jobResources}
                            {...this.props}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
